import { render, staticRenderFns } from "./importDetailCompany.vue?vue&type=template&id=2c2f79ab&scoped=true&"
import script from "./importDetailCompany.vue?vue&type=script&lang=js&"
export * from "./importDetailCompany.vue?vue&type=script&lang=js&"
import style0 from "./importDetailCompany.vue?vue&type=style&index=0&id=2c2f79ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f79ab",
  null
  
)

export default component.exports